export default {
  install(Vue) {
    // 防止重复点击
    Vue.directive('ReClick', {
      inserted(el, binding) {
        // console.log("binding-7", binding)
        el.addEventListener('click', () => {
          if (!el.disabled) {
            el.disabled = true
            setTimeout(() => {
              el.disabled = false
            }, binding.value || 5000)
          }
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/preventReClick.js